import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/helpers/auth.guard';

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  // https://angular.io/api/router/OnSameUrlNavigation
  onSameUrlNavigation: 'reload',
};

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [authGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
